import request from '@/network/http'

export function login(data) {
    return request({
        url: 'Users/OrganizationUsers/quickLogin',
        method: 'post',
        data
    })
}

export function expertLogin(data) {
    return request({
        url: 'Users/ExpertUsers/quickLogin',
        method: 'post',
        data
    })
}

export function logout() {
    return request({
        url: 'Users/OrganizationUsers/logout',
        method: 'post',
    })
}

export function expertLogout() {
    return request({
        url: 'Users/ExpertUsers/logout',
        method: 'post',
    })
}

export function updatePassword(data) {
    return request({
        url: 'Users/OrganizationUsers/updatePassword',
        method: 'post',
        data
    })
}

export function expertUpdatePassword(data) {
    return request({
        url: 'Users/ExpertUsers/updatePassword',
        method: 'post',
        data
    })
}




// WEBPACK FOOTER //
// ./src/apis/login.js